!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("ati-ui-react/components/icons/Icon")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react", "ati-ui-react/components/icons/Icon"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react"), require("ati-ui-react/components/icons/Icon")) : e["ati-ui-react"] = t(e.React, e[void 0]);
}(this, function (r, n) {
  return c = {}, o.m = i = {
    0: function (e, t) {
      e.exports = r;
    },
    1: function (e, t) {
      e.exports = n;
    },
    715: function (e, t, r) {
      "use strict";

      r.r(t), r.d(t, "default", function () {
        return o;
      });
      var t = r(0),
        n = r.n(t),
        t = r(1),
        r = r.n(t),
        t = function () {
          return n.a.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "42",
            height: "42"
          }, n.a.createElement("defs", null, n.a.createElement("linearGradient", {
            id: "fd9c93d1",
            x1: "50%",
            x2: "50%",
            y1: "0%",
            y2: "100%"
          }, n.a.createElement("stop", {
            offset: "0%",
            stopColor: "#DF0223"
          }), n.a.createElement("stop", {
            offset: "100%",
            stopColor: "#BF0111"
          }))), n.a.createElement("g", {
            fill: "none",
            fillRule: "evenodd"
          }, n.a.createElement("circle", {
            cx: "21",
            cy: "21",
            r: "21",
            fill: "url(#fd9c93d1)"
          }), n.a.createElement("path", {
            fill: "#FFF",
            d: "M30.79 12.992l-7.903 7.903 7.902 7.902-1.992 1.992-7.902-7.902-7.903 7.902L11 28.797l7.902-7.902L11 12.992 12.992 11l7.903 7.902L28.797 11z"
          })));
        };
      t.svg = {
        viewBox: "0 0 42 42"
      };
      var o = r()(t);
    }
  }, o.c = c, o.d = function (e, t, r) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (o.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var n in t) o.d(r, n, function (e) {
      return t[e];
    }.bind(null, n));
    return r;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 715);
  function o(e) {
    if (c[e]) return c[e].exports;
    var t = c[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return i[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }
  var i, c;
});